export const SALES_REGISTER_REPORT_REQUEST = 'SALES_REGISTER_REPORT_REQUEST';
export const SALES_REGISTER_REPORT_SUCCESS = 'SALES_REGISTER_REPORT_SUCCESS';
export const SALES_REGISTER_REPORT_FAILURE = 'SALES_REGISTER_REPORT_FAILURE';

export const GET_ACCOUNTS_OF_SALES_BILL_REQUEST = 'GET_ACCOUNTS_OF_SALES_BILL_REQUEST';
export const GET_ACCOUNTS_OF_SALES_BILL_SUCCESS = 'GET_ACCOUNTS_OF_SALES_BILL_SUCCESS';
export const GET_ACCOUNTS_OF_SALES_BILL_REQUEST_FAILURE = 'GET_ACCOUNTS_OF_SALES_BILL_REQUEST_FAILURE';

export const GET_ITEMS_OF_SALES_BILL_REQUEST = 'GET_ITEMS_OF_SALES_BILL_REQUEST';
export const GET_ITEMS_OF_SALES_BILL_SUCCESS = 'GET_ITEMS_OF_SALES_BILL_SUCCESS';
export const GET_ITEMS_OF_SALES_BILL_REQUEST_FAILURE = 'GET_ITEMS_OF_SALES_BILL_REQUEST_FAILURE';

export const GET_BROKERS_OF_SALES_BILL_REQUEST = 'GET_BROKERS_OF_SALES_BILL_REQUEST';
export const GET_BROKERS_OF_SALES_BILL_SUCCESS = 'GET_BROKERS_OF_SALES_BILL_SUCCESS';
export const GET_BROKERS_OF_SALES_BILL_REQUEST_FAILURE = 'GET_BROKERS_OF_SALES_BILL_REQUEST_FAILURE';

export const GET_SALE_BILLS_INVOICE_NUMBER_OF_SALES_BILL_REQUEST = 'GET_SALE_BILLS_INVOICE_NUMBER_OF_SALES_BILL_REQUEST';
export const GET_SALE_BILLS_INVOICE_NUMBER_OF_SALES_BILL_SUCCESS = 'GET_SALE_BILLS_INVOICE_NUMBER_OF_SALES_BILL_SUCCESS';
export const GET_SALE_BILLS_INVOICE_NUMBER_OF_SALES_BILL_REQUEST_FAILURE = 'GET_SALE_BILLS_INVOICE_NUMBER_OF_SALES_BILL_REQUEST_FAILURE';

export const GET_LOTS_OF_SALES_BILL_REQUEST = 'GET_LOTS_OF_SALES_BILL_REQUEST';
export const GET_LOTS_OF_SALES_BILL_SUCCESS = 'GET_LOTS_OF_SALES_BILL_SUCCESS';
export const GET_LOTS_OF_SALES_BILL_REQUEST_FAILURE = 'GET_LOTS_OF_SALES_BILL_REQUEST_FAILURE';

export const GET_FILTERS_OF_SALES_BILL_SUCCESS = 'GET_FILTERS_OF_SALES_BILL_SUCCESS';

export const SALES_REGISTER_REPORT_REQUEST_SUCCESS = 'SALES_REGISTER_REPORT_REQUEST_SUCCESS';
export const SALES_REGISTER_REPORT_REQUEST_FAILURE = 'SALES_REGISTER_REPORT_REQUEST_FAILURE';